/* interlinking-collection.js */
(() => {
  'use strict';

  function initInterlinkingCollection(root) {
    if (!root || root.dataset.ilcInitialized === 'true') return;
    root.dataset.ilcInitialized = 'true';

    const accordions = root.querySelectorAll('[data-accordion]');

    function closeAll() {
      accordions.forEach((accordion) => {
        if (!accordion.classList.contains('is-open')) return;
        accordion.classList.remove('is-open');
        const trigger = accordion.querySelector('.interlinking-collection__trigger');
        const panel = accordion.querySelector('.interlinking-collection__panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.style.maxHeight = '0';
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function openAccordion(accordion) {
      const trigger = accordion.querySelector('.interlinking-collection__trigger');
      const panel = accordion.querySelector('.interlinking-collection__panel');
      accordion.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.setAttribute('aria-hidden', 'false');
      }
    }

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('.interlinking-collection__trigger');
      const panel = accordion.querySelector('.interlinking-collection__panel');

      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('is-open');
        closeAll();
        if (!isOpen) openAccordion(accordion);
      });

      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && accordion.classList.contains('is-open')) {
          closeAll();
          trigger.focus();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.interlinking-collection').forEach((root) => {
      initInterlinkingCollection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.interlinking-collection');
    if (section) initInterlinkingCollection(section);
  });
})();
